package com.ilussobsa.views.dialogs

import com.ilussobsa.views.LogInScreen

import com.lightningkite.kiteui.models.*
import com.lightningkite.kiteui.views.*
import com.lightningkite.kiteui.views.direct.*
import com.ilussobsa.Strings
import com.ilussobsa.sdk.StoredLog
import com.ilussobsa.sdk.currentUserSessionNullable
import com.ilussobsa.sdk.masqueradeUserId
import com.ilussobsa.utils.avatar
import com.ilussobsa.utils.settings2
import com.ilussobsa.views.NotificationSettingsScreen
import com.ilussobsa.views.NotificationsScreen
import com.ilussobsa.views.SettingsScreen
import com.lightningkite.kiteui.Blob
import com.lightningkite.kiteui.Build
import com.lightningkite.kiteui.DownloadLocation
import com.lightningkite.kiteui.download
import com.lightningkite.kiteui.toBlob
import com.lightningkite.kiteui.views.l2.icon

fun  ViewWriter.userModal(close: ()->Unit) = sizeConstraints(maxWidth = 20.rem) - col {
    button {
        ::shown { masqueradeUserId() != null }
        row {
            centered - icon(Icon.close, "")
            centered - text(Strings.endMasquerade)
        }
        onClick {
            masqueradeUserId set null
        }
    }
    col {
        row {
            expanding -link {
                row {
                    centered - icon(Icon.avatar, "")
                    centered - text(Strings.myAccount)
                }
                to = { SettingsScreen() }
                onNavigate { close() }
            }
        }
        row {
            expanding - link {
                row {
                    centered - icon(Icon.settings2, "")
                    centered - text(Strings.settings)
                }
                to = { NotificationSettingsScreen() }
                onNavigate { close() }
            }
        }
        row {
            expanding - button {
                row {
                    centered - icon(Icon.star, "")
                    centered - text("Debug File Download")
                }
                onClick {
                    context.download("debug-log.txt", StoredLog.main.storedMessages.joinToString("\n") { "${it.first}: ${it.second}" }.toBlob("text/plain"), DownloadLocation.Downloads)
                }
            }
        }
        row {
            expanding - link {
                row {
                    centered - icon(Icon.logout, "")
                    centered - text {
                        ::content {
                            if (currentUserSessionNullable() != null) {
                                Strings.logOut
                            } else {
                                Strings.logIn
                            }
                        }
                    }
                }
                to = { LogInScreen() }
                onNavigate { close() }
            }
        }
        centered - subtext("Version ${Build.version} (3)")
    }
}